<app-model
  [dimensions]="{ width: 620, height: 750 }"
  [id]="sidebarName"
  [hasBackBtn]="false"
  [hasTitle]="false"
  [isNewModel]="true"
  (close)="close()"
>
  <div modal-header class="groups-model-header w-100">
    <label
      class="modal-title"
      [translatable]="{
        transKey: sidebarHeaderTitle,
        modEnum: translationModulesEnum.booking
      }"
    >
      {{ sidebarHeaderTitle | translate }}
    </label>
  </div>

  <div modal-content class="groups-model-content border-top">
    <div class="new-model-dialog-body">
      <div class="table mt-4" *ngIf="(list | search : keyword)?.length > 0">
        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th
                  scope="col"
                  [translatable]="{
                    transKey: 'events.details.userName',
                    modEnum: translationModulesEnum.Events
                  }"
                >
                  {{ "events.details.userName" | translate }}
                </th>
                <th
                  scope="col"
                  [translatable]="{
                    transKey: 'events.details.comment',
                    modEnum: translationModulesEnum.Events
                  }"
                >
                  {{ "events.details.comment" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let comment of list | search : query">
                <td>{{ comment?.name }}</td>
                <td>
                  {{ comment?.comment }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- No Comments Component -->
      <div class="no-data" *ngIf="list?.length == 0">
        <app-no-data
        [msgTranslationKey]="'events.details.noCommentsMsg'" 
        [selectedTranslationModuleEnum]="translationModulesEnum.Events"
          [msg]="'events.details.noCommentsMsg' | translate"
        >
      </app-no-data>
      </div>
    </div>

    <div class="new-model-dialog-footer">
      <span
        class="w-100"
        [translatable]="{
          transKey: 'shared.back',
          modEnum: translationModulesEnum.shared
        }"
      >
        <!-- back button -->
        <button class="btn btn-dark flex-grow-1 w-100" (click)="close()">
          {{ "shared.back" | translate }}
        </button>
      </span>
      <span class="w-100">
        <!-- save button -->
        <!-- <button
          class="btn btn-main w-100 flex-grow-1 w-100"
          [disabled]="form?.invalid || isBtnLoading"
          (click)="onSubmit()"
        >
          <i class="bx bx-loader-alt bx-spin ml-1" *ngIf="isBtnLoading"></i>
          {{ "shared.save" | translate }}
        </button> -->
      </span>
    </div>
  </div>
</app-model>
